// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Banner-cls1___df75954dcbcb6797511{/*!*/}.Banner-cls2___3df08524d5da665ad74{flex-grow:1;display:flex;align-items:flex-start;grid-gap:8px;gap:8px}@media(min-width: 375px){.Banner-cls2___3df08524d5da665ad74{align-items:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Banner-cls1___df75954dcbcb6797511",
	"cls2": "Banner-cls2___3df08524d5da665ad74 Banner-cls1___df75954dcbcb6797511"
};
export default ___CSS_LOADER_EXPORT___;
